import React from 'react';
import {Autocomplete, Button, CircularProgress, Grid, TextField} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TransformIcon from '@mui/icons-material/Transform';
import SaveIcon from '@mui/icons-material/Save';
import CourseData from "../backend/dataservices/CourseData";

function createSuggestionsData(_name, _course) {
    return {name: _name, course: _course};
}

export default function MatrixTableFunctionsRow({addCourse, transformLayout, saveLayout}) {

    const [suggestions, setSuggestions] = React.useState([]);
    const [openSuggestion, setOpenSuggestion] = React.useState(false);
    const [suggestionValue, setSuggestionValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState("");
    const [loading, setLoading] = React.useState(false);


    async function loadDataFromDatabase(rawCourseData) {
        let tempRows = [];
        for (const course of rawCourseData) {
            tempRows.push(createSuggestionsData(course.KS_Kursname, course));
        }
        return tempRows;
    }

    function generateSuggestions(rawCourseData) {
        loadDataFromDatabase(rawCourseData).then(data => {
            setSuggestions(data);
            setLoading(false);
        });
    }

    async function searchCourse(name) {
        setLoading(true);
        return CourseData.searchCourse(name).then(generateSuggestions);
    }

    function onClickAddCourse() {
        if(suggestionValue != null) {
            addCourse(suggestionValue.course.KS_ID, suggestionValue.name);
            setSuggestionValue(null);
        }
    }

    return (
        <div style={{display: "flex", flexDirection: "row"}}>
            <Autocomplete options={suggestions}
                          fullWidth
                          sx={{marginLeft: '1%', marginBottom: '1%'}}
                          open={openSuggestion}
                          onOpen={() => {
                              setOpenSuggestion(true)
                          }}
                          onClose={() => {
                              setOpenSuggestion(false)
                          }}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => {
                              setInputValue(newInputValue)
                              if (newInputValue.length >= 2) {
                                  searchCourse(newInputValue);
                              }
                          }}

                          value={suggestionValue}
                          onChange={(event, newInputValue) => {
                              setSuggestionValue(newInputValue);
                          }}
                          isOptionEqualToValue={(option, value) => option.name.includes(value.name)}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params => (
                              <TextField
                                  {...params}
                                  variant={"outlined"}
                                  label={"Suche..."}
                                  sx={{width: '100%', marginTop: '30px'}}
                                  InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                          <React.Fragment>
                                              {loading ? <CircularProgress color={"primary"}/> : null}
                                              {params.InputProps.endAdornment}
                                          </React.Fragment>
                                      ),
                                  }}
                              />
                          ))}/>

            <Grid container marginLeft={'5%'} marginTop={'1%'} marginBottom={'1%'} alignItems="center" justifyContent={"space-evenly"}>
                <Grid item xs={6}>
                    <Button disabled={suggestionValue == null} variant={"contained"} endIcon={<AddIcon/>}
                            onClick={() => {
                                onClickAddCourse();
                            }}>
                        Kurs hinzufügen
                    </Button>
                </Grid>

                <Grid item xs={4}>
                    <Grid container spacing={1} alignItems={'center'} justifyContent={'space-evenly'}>
                        <Grid item xs={12}>
                            <Button variant={"contained"} endIcon={<TransformIcon/>} color={'info'}
                                    onClick={() => {
                                        transformLayout()
                                    }}>
                                Layout transformieren
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant={"contained"} endIcon={<SaveIcon/>} color={"success"}
                                    onClick={() => {
                                        saveLayout();
                                    }}>
                                Layout speichern
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}